module.exports = __webpack_public_path__ + "assets/icon-variation-null.9686e82e.svg";